"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20RuleDisplayScene = void 0;
const Game_1 = require("./Game");
const IGO50Terminal_1 = require("./IGO50Terminal");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHRandom_1 = require("./KH/KHRandom");
const Z20AudioScene_1 = require("./Z20AudioScene");
const IGO50PausableScene_1 = require("./IGO50PausableScene");
const Z20RuleDisplay_1 = require("./Z20RuleDisplay");
const Z20SceneNames_1 = require("./Z20SceneNames");
const Z20Setup_1 = require("./Z20Setup");
const Z20TerminalSetup_1 = require("./Z20TerminalSetup");
class Z20RuleDisplayScene extends IGO50PausableScene_1.default {
    constructor() {
        super(Z20SceneNames_1.default.RuleDisplay);
    }
    init(data) {
        if (!data || !data.config)
            console.log("Rule display didn't get config");
        this.config = (data === null || data === void 0 ? void 0 : data.config) ? data.config : Z20TerminalSetup_1.Z20TerminalSetup.StandardSetup;
        this.seed = data === null || data === void 0 ? void 0 : data.seed;
    }
    create() {
        IGO50Terminal_1.default.CurrentCode = 'WOOD-SEED';
        if (this.seed === undefined) {
            this.seed = Math.floor(Math.random() * 1000000);
        }
        console.log('Seed', this.seed);
        const random = new KHRandom_1.KHRandomSeedable(this.seed);
        this._setup = new Z20Setup_1.Z20Setup(random, 6, this.config);
        this.add.existing(new Z20RuleDisplay_1.Z20RuleDisplay(this, Game_1.game.width / 2, Game_1.game.height / 2, this._setup, true));
        this._controller = Game_1.gameManager.getController();
        this._controller.register(KHInputScene_1.KHInputScene.SharedInput);
        const startKey = this._controller.getInput(Game_1.Controls.Confirm);
        startKey.registerCallbackForObject('justDown', this, () => {
            if (this.scene.isPaused(this.scene.key) || this.scene.isSleeping(this.scene.key)) {
                return;
            }
            Z20AudioScene_1.Z20AudioScene.Shared.playSfx('move');
            this.scene.start(Z20SceneNames_1.default.Game, { config: this.config, setup: this._setup });
        });
        this.events.on(Phaser.Scenes.Events.SHUTDOWN, () => {
            startKey.unregisterCallbacksForObject('justDown', this);
        });
    }
}
exports.Z20RuleDisplayScene = Z20RuleDisplayScene;
